import React, { useEffect } from "react";
import { Modal, Typography, Divider, Spin, Empty } from "antd";

import PrimaryButton from "../Forms/PrimaryButton";
import { downloadFile, formatDate } from "../../utils";
import { orderStatus } from "../../constant";
import { PiChat, PiChatText } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import CustomBadge from "../Charts/CustomBadge";
import { useApiCall } from "../../services/api";
import { notificationRefresh } from "../../redux/auth/cartRefreshSlice";

const { Title } = Typography;

export default function ViewHistoryModal({
  open,
  onClose,
  title = "Edit History",
  loading,
  orderData,
  setFetchRefresh,
}) {
  const { postApi } = useApiCall();
  const { is_sales_manager, is_admin, is_customer, role } = useSelector((state) => state.auth);
  const view_history = orderData?.edit_history || [];
  const dispatch = useDispatch();

  const sortedHistory = [...view_history].sort((a, b) => b.id - a.id);

  const unSeenHistory = sortedHistory.filter((item) => {
    return is_sales_manager
      ? !item.is_salesmanger
      : is_admin
        ? !item.is_admin
        : is_customer
          ? !item.is_customer
          : !item.is_salesperson;
  });

  useEffect(() => {
    if (open && unSeenHistory.length > 0) {
      const markAsSeen = async () => {
        try {
          const res = await postApi("sales/common/view-notification", {
            id: unSeenHistory.map((item) => item.id),
            role: is_customer ? "Customer" : role,
          });

          if (res?.status) {
            dispatch(notificationRefresh());
          }
        } catch (err) {
          console.error("Error marking notification as seen:", err);
        }
      };
      markAsSeen();
    }
  }, [open, unSeenHistory.length]);

  return (
    <Modal
      className="form-css custom-modal my-5"
      open={open}
      footer={null}
      onCancel={() => {
        onClose();
        if (unSeenHistory.length > 0) setFetchRefresh((prev) => !prev);
      }}
      centered
      width={500}
    >
      <Title level={2} className="font-abhaya mb-3">
        Order #{orderData?.order_id} {title}
      </Title>

      {/* ✅ Loading state */}
      {loading ? (
        <div className="flex justify-center items-center py-10">
          <Spin size="large" />
        </div>
      ) : sortedHistory.length === 0 ? (
        /* ✅ Empty state */
        <Empty description="No view history found" />
      ) : (
        sortedHistory.map((item, index) => (
          <div
            key={index}
            className="rounded-2xl border border-[#D9D9D9] p-3 flex flex-col justify-between mb-3"
          >
            {/* Header */}
            <div className="">
              <div className="grid gap-1">
                <div className="flex justify-between">
                  <p className="text-[#000000] text-lg font-semibold">{item.title}</p>
                  {(is_sales_manager
                    ? !item.is_salesmanger
                    : is_admin
                      ? // ? !item.is_admin
                        false
                      : is_customer
                        ? !item.is_customer
                        : !item.is_salesperson) && <CustomBadge text={"New"} variant="primary" />}
                </div>
                <p className="text-[#666666]">
                  {formatDate(item.created_at, { format: "D MMM YYYY h:mma" })}
                </p>
                {/* <p className="text-[#000000] text-base leading-6">{item.message}</p> */}
                <div className="mt-2">
                  {item?.long_message && (
                    <p className="text-[#666666]">
                      {item.long_message.split("\n").map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </Modal>
  );
}
